import Loadable from '../../../utils/loadable';

const SpecialGift = Loadable(() => (import('../FuncContainers/specialGift')));
export default SpecialGift;
